import { render } from "./TagsModalComponent.vue?vue&type=template&id=21034df2&scoped=true&ts=true"
import script from "./TagsModalComponent.vue?vue&type=script&lang=ts"
export * from "./TagsModalComponent.vue?vue&type=script&lang=ts"

import "./TagsModalComponent.vue?vue&type=style&index=0&id=21034df2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21034df2"]])

export default __exports__